import { scrollTo } from "../../assets/js/functions";

(function ($) {

    function ajax_request($el) {
        let form = $el;

        if (form.data('requestRunning')) {
            return;
        }
        form.data('requestRunning', true);

        let data = {
            'action': 'posts_grid_loadmore',
        };

        form.find('input, select').each(function () {
            data[$(this).attr('name')] = $(this).val();
        });

        $.ajax({
            url: theme.ajaxurl,
            data: data,
            type: 'POST',
            beforeSend: function () {
            },
            success: function (data) {
                if (data) {
                    $('.block--posts-grid .content').html(data);
                    scrollTo($('.block--posts-grid .content'), 20);
                }
            },
            complete: function() {
                form.data('requestRunning', false);
            },
        });
    }

    var initializeBlock = function ($block) {
        $block.find('form').submit(function (e) {
            e.preventDefault();
            $(this).find('[name="query_paged"]').val(1);
            ajax_request($(this));
        });
    }

    $(document).ready(function () {
        $('.block--posts-grid').each(function () {
            initializeBlock($(this));
        })

        $(document).on('click', '.block--posts-grid .pagination a.page-numbers', function(e) {
            e.preventDefault();
            const parent = $(this).closest('.block--posts-grid');
            parent.find('form [name="query_paged"]').val($(this).text());
            ajax_request(parent.find('form'));
        });
    })

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=posts-grid', initializeBlock);
    }

})(jQuery);
